import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from '../../reducers/auth';
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { resolveImageUrl, resolveSwatchUrl } from '../../utils/imageUrl';

const PRICING_TYPES = {
  FLAT: 1,
  QUANTITY: 2,
  BILL_LATER: 3
};

const Product = (props) => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const navigate = useNavigate();
  const loginStatus = useSelector(isLoggedIn);
  const [imgSrc, setImgSrc] = useState(null);
  const [currentColor, setCurrentColor] = useState(null);

  const imageOver = (item) => {
    setImgSrc(item.modelImage);
    setCurrentColor(item);
  }
  var showColors = true;
  if (props.showColors && props.showColors === "hide") {
    showColors = false;
  }
  let featuredColor = null;
  const colors = props.product.colors || [];

  if (props.product.featuredColor != null && colors.length > 0) {
    for (var i = 0; i < colors.length; i++) {
      if (colors[i].colorId === props.product.featuredColor) {
        featuredColor = colors[i];
      }
    }
  }
  console.log("PRODUCT", props.product);
  if (featuredColor === null && colors.length > 0)
    featuredColor = colors[0];

  // If no colors available, return null to avoid render errors
  if (!featuredColor) {
    return null;
  }

  var imageUrl = "";
  if (featuredColor.modelImage) {
    if (featuredColor.modelImage.includes("uploads")) {
      imageUrl = apiUrl + featuredColor.modelImage;
    } else if (featuredColor.modelImage.startsWith("Images") || /^https?:\/\//i.test(featuredColor.modelImage)) {
      imageUrl = resolveImageUrl(featuredColor.modelImage);
    } else if (props.baseUrl) {
      imageUrl = props.baseUrl + featuredColor.modelImage;
    } else {
      imageUrl = featuredColor.modelImage;
    }
  }
  return (
    <Col xs={12} sm={6} md={4} lg={2} style={{ paddingRight: 4, paddingLeft: 4, paddingBottom: 4, paddingTop: 4 }}>
      <div className="product" style={props.product.hidden ? { opacity: 0.6, border: '2px solid #dc3545' } : {}}>
        <div onClick={() => { navigate(props.url ? props.url + props.product.id : `../admin/product/details/` + props.product.id, { state: { productId: props.product.id, colorId: currentColor?.colorId }, replace: true }); }}>
          {props.product.hidden == 1 && (
            <div style={{ backgroundColor: '#dc3545', color: 'white', padding: '2px 8px', fontSize: '12px', textAlign: 'center' }}>
              HIDDEN
            </div>
          )}
          <div className="modelImage"><img src={imageUrl} alt="Model Image" width="100%" /></div>
          <div className="title">{props.product.title}</div>
          {/* Flat pricing (default) */}
          {(!props.product.pricingType || props.product.pricingType === PRICING_TYPES.FLAT) && (
            <div className="price">${props.product.costSingle2X}</div>
          )}
          {/* Quantity pricing */}
          {props.product.pricingType === PRICING_TYPES.QUANTITY && (
            <div className="price" style={{ fontSize: '0.9em' }}>Quantity Pricing</div>
          )}
          {/* Bill later pricing */}
          {props.product.pricingType === PRICING_TYPES.BILL_LATER && (
            <div className="price" style={{ color: '#666', fontStyle: 'italic' }}>Billed Later</div>
          )}
          <div className="colors">
            <div style={{ width: "100%", textAlign: "center" }}>
              {props.product.colorCount} Colors available
            </div>
          </div>
          {showColors &&
            <Container>
              <Row>
                <Col className="colors">
                  {props.product.colors.map((color, idx) => (
                    <div className={`color-swatch`} key={color.colorId || idx}>
                      {color.hexColor && color.hexColor != "" && !(color.colorImage && color.colorImage != "") && (
                        <div style={{ backgroundColor: color.hexColor, width: 20, height: 20 }}></div>
                      )}
                      {color.colorImage && color.colorImage != "" && (
                        <img src={resolveSwatchUrl(color.colorImage)} alt={`${color.colorName}`} height={20}
                          onMouseOver={(event) => imageOver(color)}
                        />
                      )}
                    </div>
                  ))}

                </Col>
              </Row>
            </Container>
          }
        </div>
      </div>
    </Col>
  );
};

export default Product;
